<template>
    <div class="transaction-container">
        <!-- 搜索区域 -->
        <el-card class="search-card" shadow="never" style="margin-bottom: 20px;">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline" size="small">
                <el-form-item label="高校">
                    <el-select v-model="queryParams.schoolId" :placeholder="schoolLocked ? '本校' : '全部高校'" :clearable="!schoolLocked" :disabled="schoolLocked" style="width: 200px;">
                        <el-option v-if="!schoolLocked" label="全部高校" value=""></el-option>
                        <el-option v-for="s in schoolList" :key="s.schoolId || s.id" :label="s.schoolName || s.school_name" :value="s.schoolId || s.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="按日期">
                    <el-date-picker
                        v-model="queryParams.dateFilter"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="按日筛选"
                        size="small"
                        style="width: 160px;"
                        clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="按月份">
                    <el-date-picker
                        v-model="queryParams.monthFilter"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="按月筛选"
                        size="small"
                        style="width: 160px;"
                        clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="订单号">
                    <el-input v-model="queryParams.orderId" placeholder="请输入订单号查询" clearable style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="收益类型">
                    <el-select v-model="queryParams.type" placeholder="请选择类型" clearable style="width: 140px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="兼职收益" value="兼职收益"></el-option>
                        <el-option label="平台提成" value="平台提成"></el-option>
                        <el-option label="负责人提成" value="负责人提成"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" icon="el-icon-search" @click="getList()">查询</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
                    <el-button
                        type="success"
                        size="mini"
                        icon="el-icon-download"
                        :loading="exportLoading"
                        @click="exportReport">
                        导出报表
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 数据统计卡片 -->
        <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-total">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-wallet"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">总交易额</div>
                            <div class="stat-value">¥{{ stats.totalAmount }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-count">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-s-order"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">交易笔数</div>
                            <div class="stat-value">{{ stats.totalCount }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-avg">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-data-line"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">平均金额</div>
                            <div class="stat-value">¥{{ stats.avgAmount }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-today">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-date"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">今日交易额</div>
                            <div class="stat-value">¥{{ stats.todayAmount }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 表格区域：列表展示用户实付金额（每单一条） -->
        <el-card shadow="never" class="table-card">
        <el-table :data="list" class="transaction-table" v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center"/>
            <el-table-column label="订单号" prop="orderId" min-width="200">
                <template slot-scope="scope">
                    <span style="color: var(--primary-color); cursor: pointer;" @click="viewOrderDetail(scope.row)">{{ scope.row.orderId }}</span>
                    <span class="detail-hint">（点击查看分配明细）</span>
                </template>
            </el-table-column>
            <el-table-column label="用户实付金额" width="160" align="right">
                <template slot-scope="scope">
                    <div class="cell-right">
                        <span style="color: #00C2A8; font-weight: 600; font-size: 16px;">¥{{ formatAmount(scope.row.payAmount) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易时间" prop="createTime" width="180" align="right">
                <template slot-scope="scope">
                    <div class="cell-right">{{ scope.row.createTime | dateFormat }}</div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分配明细弹窗：查看该笔订单的金额如何分配 -->
        <el-dialog title="金额分配明细" :visible.sync="detailVisible" width="560px" append-to-body>
            <div v-if="detailLoading" style="text-align: center; padding: 20px;"><i class="el-icon-loading"></i> 加载中...</div>
            <template v-else>
                <p v-if="detailOrderId" class="detail-order-id">订单号：<strong>{{ detailOrderId }}</strong></p>
                <el-table :data="detailList" size="small" border>
                    <el-table-column type="index" label="序号" width="60" align="center"/>
                    <el-table-column label="分配类型" prop="type" width="140">
                        <template slot-scope="scope">
                            <el-tag size="small" effect="plain">{{ scope.row.type }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="金额" align="right">
                        <template slot-scope="scope">
                            <div class="cell-right"><span style="color: #00C2A8; font-weight: 600;">¥{{ formatAmount(scope.row.orderPrice) }}</span></div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="detailList.length === 0 && !detailLoading" style="text-align: center; color: #909399; padding: 16px;">暂无分配记录</div>
            </template>
        </el-dialog>

        <!-- 空状态 -->
        <div v-if="!loading && list.length === 0" style="text-align: center; padding: 60px 20px; color: #909399;">
            <i class="el-icon-document" style="font-size: 64px; color: #dcdfe6; margin-bottom: 16px;"></i>
            <p style="font-size: 14px;">暂无交易数据</p>
        </div>

        <!-- 分页 -->
        <template v-if="list.length!=0">
            <el-pagination 
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :current-page="queryParams.pageNum" 
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize" 
                layout="total, sizes, prev, pager, next, jumper" 
                :total="total"
                style="margin-top: 20px;">
            </el-pagination>
        </template>
        </el-card>
    </div>
</template>

<script>
import { downloadReport } from '@/assets/js/reportDownload'
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'

export default {
    name: 'TransactionDetail',
    computed: {
        schoolLocked() {
            return isSchoolScoped();
        }
    },
    data() {
        return {
            loading: false,
            exportLoading: false,
            list: [],
            total: 0,
            schoolList: [],
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                orderId: '',
                type: '',
                schoolId: '',
                dateFilter: '',
                monthFilter: '',
                year: null,
                month: null,
                day: null
            },
            stats: {
                totalAmount: '0.00',
                totalCount: 0,
                avgAmount: '0.00',
                todayAmount: '0.00'
            },
            detailVisible: false,
            detailLoading: false,
            detailOrderId: '',
            detailList: []
        }
    },
    mounted() {
        this.loadSchoolList();
        this.getList();
    },
    methods: {
        async loadSchoolList() {
            try {
                const { data: res } = await this.$http.get('/init/getSchoolList');
                if (res.code === 200 && Array.isArray(res.data)) {
                    this.schoolList = lockSchoolOptions(res.data);
                    if (isSchoolScoped() && getBoundSchoolId() != null) {
                        this.queryParams.schoolId = getBoundSchoolId();
                    }
                }
            } catch (e) {
                console.warn('loadSchoolList error', e);
            }
        },
        buildListParams() {
            const p = {
                pageNum: this.queryParams.pageNum,
                pageSize: this.queryParams.pageSize,
                orderId: this.queryParams.orderId || undefined,
                type: this.queryParams.type || undefined,
                schoolId: this.queryParams.schoolId || undefined
            };
            if (this.queryParams.dateFilter) {
                const parts = this.queryParams.dateFilter.split('-').map(Number);
                if (parts.length >= 1) p.year = parts[0];
                if (parts.length >= 2) p.month = parts[1];
                if (parts.length >= 3) p.day = parts[2];
            } else if (this.queryParams.monthFilter) {
                const parts = this.queryParams.monthFilter.split('-').map(Number);
                if (parts.length >= 1) p.year = parts[0];
                if (parts.length >= 2) p.month = parts[1];
            }
            return p;
        },
        async getList() {
            this.loading = true;
            try {
                const params = this.buildListParams();
                const { data: res } = await this.$http.get('/money/getCampusMoneyList', { params });
                if (res.code === 200 && res.data) {
                    this.list = res.data.records || [];
                    this.total = res.data.total || 0;
                    this.stats.totalAmount = (res.data.totalAmount != null ? res.data.totalAmount : '0.00').toString();
                    this.stats.totalCount = this.total;
                    this.stats.avgAmount = this.total > 0 ? (parseFloat(this.stats.totalAmount) / this.total).toFixed(2) : '0.00';
                    this.stats.todayAmount = (res.data.todayAmount != null ? res.data.todayAmount : '0.00').toString();
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            } catch (error) {
                console.error('获取交易明细失败:', error);
                this.$message.error('获取数据失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },
        
        async exportReport() {
            this.exportLoading = true;
            try {
                const params = this.buildListParams();
                delete params.pageNum;
                delete params.pageSize;
                await downloadReport(
                    this.$http,
                    '/admin/report/export/transactions',
                    params,
                    '交易明细报表.xlsx'
                );
                this.$message.success('交易明细报表导出成功');
            } catch (error) {
                this.$message.error(error.message || '交易明细报表导出失败');
            } finally {
                this.exportLoading = false;
            }
        },
        
        formatAmount(val) {
            if (val == null || val === '') return '0.00';
            const n = parseFloat(val);
            return isNaN(n) ? '0.00' : n.toFixed(2);
        },
        async viewOrderDetail(row) {
            const orderId = row.orderId;
            if (!orderId) return;
            this.detailOrderId = orderId;
            this.detailVisible = true;
            this.detailList = [];
            this.detailLoading = true;
            try {
                const { data: res } = await this.$http.get('/money/getMoneyDetailByOrderId', { params: { orderId } });
                if (res.code === 200 && Array.isArray(res.data)) {
                    this.detailList = res.data;
                } else {
                    this.$message.warning(res.msg || '暂无分配明细');
                }
            } catch (e) {
                this.$message.error('获取分配明细失败');
                console.error(e);
            } finally {
                this.detailLoading = false;
            }
        },
        
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                orderId: '',
                type: '',
                schoolId: isSchoolScoped() ? (getBoundSchoolId() || '') : '',
                dateFilter: '',
                monthFilter: '',
                year: null,
                month: null,
                day: null
            };
            this.$router.replace({ query: {} });
            this.getList();
        },
        
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style scoped>
.transaction-container {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 64px);
}

/* 搜索卡片 */
.search-card {
    border-radius: 12px;
    margin-bottom: 20px;
}

/* 统计卡片样式 */
.stat-card {
    border-radius: 12px;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-4px);
}

.stat-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
}

.stat-card-total .stat-icon {
    background: linear-gradient(135deg, rgba(0, 194, 168, 0.1), rgba(0, 194, 168, 0.2));
    color: #00C2A8;
}

.stat-card-count .stat-icon {
    background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.2));
    color: #1890ff;
}

.stat-card-avg .stat-icon {
    background: linear-gradient(135deg, rgba(250, 173, 20, 0.1), rgba(250, 173, 20, 0.2));
    color: #faad14;
}

.stat-card-today .stat-icon {
    background: linear-gradient(135deg, rgba(114, 46, 209, 0.1), rgba(114, 46, 209, 0.2));
    color: #722ed1;
}

.stat-info {
    flex: 1;
}

.stat-label {
    font-size: 14px;
    color: #909399;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
}

.detail-hint {
    font-size: 12px;
    color: #909399;
    margin-left: 6px;
}
.detail-order-id {
    margin-bottom: 12px;
    color: #606266;
}

/* 表格单元格右对齐，与表头 align="right" 一致 */
.cell-right {
    text-align: right;
    width: 100%;
}

/* 表格样式优化 */
::v-deep .el-table th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

/* 表格占满卡片宽度 */
.table-card ::v-deep .el-card__body {
    padding: 20px;
}
.transaction-table {
    width: 100% !important;
}
::v-deep .transaction-table.el-table {
    border-radius: 8px;
    overflow: hidden;
}
::v-deep .el-table {
    border-radius: 8px;
    overflow: hidden;
}

::v-deep .el-pagination {
    margin-top: 20px;
    text-align: right;
}
</style>

